/**
 * Nested eager-load paths for agreement payments + payment method on invoice detail
 * and on account-receivable detail (nested `invoice.*`). Single source of truth vs AR APIs.
 */
export const invoiceAccountReceivablePaymentDetailIncludeFragments = [
  'account_receivables.account_receivable_payments.ar_payment_collection.payment_transactions.agreement_payments',
  'account_receivables.account_receivable_payments.ar_payment_collection.payment_transactions.payment_method',
] as const;
